
const digest = '2f0e13d99d0aa5c28bd06d38bd8c9d69c29e3e1bffed2bbe8a119280ee2ae911';
const classes = {"wrapper":"_wrapper_1hzv2_1","date":"_date_1hzv2_12","content":"_content_1hzv2_19","item":"_item_1hzv2_27","title":"_title_1hzv2_33","text":"_text_1hzv2_36","controls":"_controls_1hzv2_39"};
const css = `._wrapper_1hzv2_1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 28px;
  border: 1px solid #eaedf3;
  border-top: 0;
}
._wrapper_1hzv2_1:first-of-type {
  border-top: 1px solid #eaedf3;
}
._wrapper_1hzv2_1 ._date_1hzv2_12 {
  font-size: 14px;
  color: #000000;
  max-width: 120px;
  padding: 24px 0 24px 24px;
  min-width: 160px;
}
._wrapper_1hzv2_1 ._content_1hzv2_19 {
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  gap: 10px;
  padding: 24px 0;
  flex-wrap: wrap;
}
._wrapper_1hzv2_1 ._content_1hzv2_19 ._item_1hzv2_27 {
  display: flex;
  flex-direction: row;
  gap: 5px;
  font-size: 14px;
}
._wrapper_1hzv2_1 ._content_1hzv2_19 ._item_1hzv2_27 ._title_1hzv2_33 {
  color: grey;
}
._wrapper_1hzv2_1 ._content_1hzv2_19 ._item_1hzv2_27 ._text_1hzv2_36 {
  color: #000000;
}
._wrapper_1hzv2_1 ._controls_1hzv2_39 {
  border-left: 1px solid #eaedf3;
  padding: 24px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  